import React, { useEffect, useState } from "react";
import {
  API_ROOT,
  PROJECT_ID,
  ENV_NAME,
  SSO_URL_GOOGLE,
  SSO_URL_OTHER,
  SSO_URL_ADFS,
  URL,
} from "../config";
import {
  TextField,
  InputAdornment,
  Button,
  Icon,
  IconButton,
  CircularProgress,
} from "@mui/material";
import { loginUser } from "../services/authService";
import Utils from "../utilities";

const LoginModal = (props) => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [errors, setErrors] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [appVersion, setAppVersion] = useState("1.0.0");

  useEffect(() => {
    setVersion();
    if(!errors.length) ssoVerifyLogin();
  }, []);

  const setVersion = async () => {
    let ver = await Utils.getStoredValue("version");
    if (ver !== "undefined") setAppVersion(ver);
  };

  const ssoVerifyLogin = () => {
    let params = new URLSearchParams(window.location.search);
    let provider = params.get("provider");
    if (provider) {
      let params1 = new URLSearchParams(window.location.hash.substring(1));
      let token = params1.get("access_token");

      loginUser({ username: provider, password: token })
        .then((response) => {
          if (response.data.code === 200) {
            props.setLoggedIn(response.data.response);
            if (PROJECT_ID) {
              props.setDomain(PROJECT_ID);
            }

            window.location.href =
              window.location.origin + window.location.pathname;
          } else {
            setErrors([response.data.message]);
            setLoading(false);
          }
        })
        .catch((_error) => {
          setLoading(false);
          setErrors(["Connection Timeout"]);
        });
    }
  };

  // const getGlobalConfig = () => {
  //   cohortPreviewExportService.getCohortGlobalConfig().then(
  //     ({ data }) => {
  //       if (data.code === 200) {
  //         Utils.setStoredValue('global', data?.response);
  //       }else{
  //         console.error('something went wrong');
  //       }
  //     },
  //     (error) => {
  //       console.log(error, 'error');
  //     }
  //   );
  // };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!username.length || !password.length) {
      setErrors(["Username or password cannot be empty."]);
      return;
    }

    setLoading(true);
    setErrors([]);
    props.resetLoggedIn();

    loginUser({ username, password })
      .then((response) => {
        if (response.data.code === 200) {
          setLoading(false);
          const apiResponse = response.data.response;
          props.setLoggedIn(apiResponse);
          //getGlobalConfig();
          if (PROJECT_ID) {
            props.setDomain(PROJECT_ID);
          }

          document.getElementById("domain").focus();
        } else {
          setErrors([response.data.message]);
          setLoading(false);
        }
      })
      .catch((_error) => {
        setLoading(false);
        setErrors(["Connection Timeout"]);
      });
  };

  const domainValue = (val) => {
    props.setDomain(val.target.value);
  };

  return (
    <div className="container-fluid">
      <div className="row justify-content-center align-items-center" style={{height:"100vh", background: "linear-gradient(160deg, #fff, #f1f3f4"}}>
        <div className="d-flex login-modal">
          <div className="text-center flex-grow-1">
            <img
              className="img-fluid"
              src={`${URL}image-login-cropped.png`}
              alt="lighthouse"
            />
          </div>
          <div className="d-flex align-item-center justify-content-center bg-white px-4 pt-4 login-content">
            <div className="text-center px-4 pt-3">
              <div>
                <img
                  src={`${URL}lighthouse-logo-black.png`}
                  style={{ width: "16rem" }}
                  alt="lighthouse"
                />
                <h6 className="text-muted font-weight-normal mt-2 mb-1">{ENV_NAME}</h6>
                <p className="fs15 text-center text-muted pb-3 app-version">
                  Version {appVersion}
                </p>
              </div>
              <form className="needs-validation" noValidate>
                <TextField
                  className="w-100 mb-4"
                  required
                  size="small"
                  variant="outlined"
                  label="Username"
                  name="username"
                  autoComplete="off"
                  InputLabelProps={{ shrink: true }}
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                />
                <label htmlFor="password-input" className="d-none">
                  Password
                </label>
                <TextField
                  id="password-input"
                  className="w-100"
                  required
                  size="small"
                  label="Password"
                  name="password"
                  variant="outlined"
                  type={showPassword ? "text" : "password"}
                  InputLabelProps={{ shrink: true }}
                  onChange={(e) => setPassword(e.target.value)}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          className="outline-none toggle-password-visibility"
                          onClick={() => setShowPassword(!showPassword)}
                          data-testid="visibility-btn"
                        >
                          {showPassword ? <Icon>visibility</Icon> : <Icon>visibility_off</Icon>}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
                <div className="text-right small mb-3">
                  <a
                    href={`${API_ROOT}forgetPassword?redirect_uri=${window.location.origin}${URL}`}
                  >
                    Forgot Password?
                  </a>
                </div>
                {props.loggedIn && (
                  <div id="login1">
                    <select
                      id="domain"
                      className="form-control mb-3"
                      onChange={(e) => domainValue(e)}
                      data-testid="choose-domain"
                    >
                      <option>Choose Domain</option>
                      <option value="1">CX</option>
                      <option value="2">RWE</option>
                      <option value="4">Test</option>
                    </select>
                  </div>
                )}
                <Button
                  type="submit"
                  className={`${
                    loading ? "bg-light text-muted" : "bg-primary-blue text-white"
                  } w-100 px-3`}
                  disabled={loading}
                  onClick={(e) => handleSubmit(e)}
                >
                  {loading ? (
                    <CircularProgress
                      size={25}
                      className="text-muted circular-progress"
                    />
                  ) : (
                    `Sign In`
                  )}
                </Button>
                <p className="text-center small text-danger mt-2">
                  {errors.map((error, i) => (
                    <span key={i}>{error}</span>
                  ))}
                </p>
              </form>
              <p className="fs14 w-75 text-muted line">
                <span>Or sign in with</span>
              </p>
              <div className="d-flex justify-content-center login-icon-btn">
                <div>
                  <section>
                    <button
                      name="sso-google"
                      onClick={() => (window.location.href = SSO_URL_GOOGLE)}
                    >
                      <img
                        src={`${URL}Google.png`}
                        width="20"
                        alt="lighthouse"
                      />
                    </button>
                  </section>
                  <label>Google</label>
                </div>
                <div>
                  <section>
                    <button
                      name="sso-other"
                      onClick={() => (window.location.href = SSO_URL_OTHER)}
                    >
                      <img
                        src={`${URL}SSO.png`}
                        width="22"
                        alt="lighthouse"
                      />
                    </button>
                  </section>
                  <label>OneLogin</label>
                </div>
                <div>
                  <section>
                    <button
                      name="sso-adfs"
                      onClick={() => (window.location.href = SSO_URL_ADFS)}
                    >
                      <img
                        src={`${URL}ADFS.png`}
                        width="22"
                        alt="lighthouse"
                      />
                    </button>
                  </section>
                  <label>Incedo ADFS</label>
                </div>
              </div>
              <p className="fs12 text-muted mt-4 mb-0">Powered By Incedo</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginModal;
